import React from 'react';
import {Field, reduxForm, focus} from 'redux-form';
import Input from '../Input/Input';
import {login} from '../../../actions/auth';
import {required, nonEmpty} from '../../../validators';

export class LoginForm extends React.Component {
    onSubmit(values) {
        return this.props.dispatch(login(values.username, values.password));
    }

    render() {
        let error;
        if (this.props.error) {
            error = (
                <div className="form-error" aria-live="polite">
                    {this.props.error}
                </div>
            );
        }
        return (
            <form className="login-form"
                  onSubmit={this.props.handleSubmit(values =>
                    this.onSubmit(values))}>
                {error}
                <div className='login-wrapper'> 
                    <label htmlFor="username">Username:</label>
                    <Field
                        component={Input}
                        type="text"
                        name="username"
                        id="username"
                        validate={[required, nonEmpty]}
                    />
                </div>
                <div className='login-wrapper'>
                    <label htmlFor="password">Password:</label>
                    <Field
                        component={Input}
                        type="password"
                        name="password"
                        id="password"
                        validate={[required, nonEmpty]}
                    />
                </div>
                <button className='btn btn-login' disabled={this.props.pristine || this.props.submitting}>
                    LOGIN
                </button>
            </form>
        );
    }
}

export default reduxForm({
    form: 'login',
    onSubmitFail: (errors, dispatch) => dispatch(focus('login', 'username'))
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Auth/Login/LoginForm.js